/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { AdditionalServicesTypes, AdditionalServicesState } from './types';

const INITIAL_STATE: AdditionalServicesState = {
  additionalServices: [],
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<AdditionalServicesState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case AdditionalServicesTypes.GET_ADDITIONAL_SERVICES_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case AdditionalServicesTypes.GET_ADDITIONAL_SERVICES_SUCCESS:
        draft.additionalServices = result.data.servicos;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case AdditionalServicesTypes.GET_ADDITIONAL_SERVICES_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
